import React, { useEffect, useState } from 'react'
import { useTranslation } from 'next-i18next'
import { MePayoutTransactionDetail } from '../../../../../../types/Payout/MePayoutTransactionDetail'
import DisplayPayoutRevenues from '../../../../../shared/DisplayPayoutRevenues'
import { Property } from '../../../../../../types/Property/Property'
import useLocale from '../../../../../../hooks/useLocale'
import propertyService from '../../../../../../services/property.service'
import { useNotification } from '../../../../../../providers/NotificationProvider'

interface PayoutTransactionDetailsTabElemProps {
  payoutTransactionDetail: MePayoutTransactionDetail
}

export default function PayoutTransactionDetailsTabElem({
  payoutTransactionDetail,
}: PayoutTransactionDetailsTabElemProps) {
  const { t } = useTranslation('dashboard')
  const { locale } = useLocale()

  const { error: displayError } = useNotification()

  const [property, setProperty] = useState<Property>()

  const [fetchPropertyIsLoading, setFetchPropertyIsLoading] =
    useState<boolean>(false)

  const fetchProperty = async (propertyId: string): Promise<void> => {
    setFetchPropertyIsLoading(true)
    try {
      const property: Property = await propertyService.getProperty({
        id: propertyId,
        lang: locale,
      })
      setProperty(property)
    } catch (err) {
      displayError(
        t('payoutsReview.tab.errors.fetchPayout.title'),
        t('payoutsReview.tab.errors.fetchPayout.text'),
        10000,
      )
    } finally {
      setFetchPropertyIsLoading(false)
    }
  }

  useEffect(() => {
    fetchProperty(payoutTransactionDetail.property.id)
  }, [payoutTransactionDetail, locale])

  return (
    <div className="flex items-center p-1.5">
      <div>
        <p className="text-lg font-medium text-gray-800">
          {payoutTransactionDetail.amount && (
            <DisplayPayoutRevenues
              revenues={payoutTransactionDetail.amount}
              currency={payoutTransactionDetail.currency}
              digitAfterDecimalPoint={2}
              decimals={2}
            />
          )}
        </p>
        <p className="mt-1 text-sm text-gray-600">
          {t('payoutsReview.tabDetails.transactionDetails.tab.grossPayout')}
        </p>
      </div>
      <div className="flex grow items-center justify-end">
        <p className="text-sm text-gray-700">
          {property ? property.translation.title : 'N/A'}
        </p>
      </div>
    </div>
  )
}
